<template>
  <header class="py-2 text-center">
    <div class="container">
      <div class="row">
        <div class="col">
         
            <a class="navbar-brand" href="/">
              <img src="@/assets/img/logo.png" alt="Chamdor Logo" height="86" />
            </a>
           
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <div class="text-center border-top border-bottom py-2 font-size-13">
             <a class="font-weight-bold text-body mr-3" href="/about">ABOUT</a>
             <a class="font-weight-bold text-body mr-3" href="https://chamdor.com">SHOP</a>
             <a class="font-weight-bold text-body" href="https://chamdor.com/pages/contact">CONTACT</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style>
</style>